window.onscroll = function() {scrollFunction()};

function scrollFunction() {
    if ($(window).width() <= 768 ){
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            $('.col-form-career').css('margin-top', 0)

            if ($(window).height() < 740 ){
                if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                    $('.first-space').css('padding-top', '250px')
                }else{
                    $('.first-space').css('padding-top', '100px')
                }
            }else{
                $('.first-space').css('padding-top', '100px')
            }
        }else{
            $('.col-form-career').css('margin-top', 230)
        }
    }

}
$( "#cv" ).change(function() {
    const a = document.getElementById('cv');
    if(a.value == "")
    {
        $('#fileLabel').text('Upload Resume');
        $('#fileLabel').css('color', '#bbb');
    }
    else
    {
        $('#fileLabel').css('color', '#000');
        const theSplit = a.value.split('\\');
        const textfile = theSplit[theSplit.length - 1];
        const fileExtension = textfile.substring(textfile.lastIndexOf('.') + 1);
        const filename = textfile.replace(fileExtension, '');
        if (filename.length > 8) {
            $('#fileLabel').text(filename.substring(0, 7) + '...'+fileExtension);
        }else{
            $('#fileLabel').text(filename.substring(0, 7) + fileExtension);
        }
    }
});
$( "#kota" ).change(function() {
    console.log('dsd')
    $('#kota').css('background-color','red !important')
})

function faq_detail(text){
    $(".btn-faq").removeClass('active')
    $("#faq-detail").html('<p class="animate__animated animate__faster animate__fadeInLeftBig">'+text+'</p>')
}
